import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function WaysToVoteRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  // using this format to populate data to avoid errors when compiling locally
  const SdrEarlyVoting = stateData.has_sdr_early_voting
    ? stateData.has_sdr_early_voting.bool_value
    : 'N/A';
  const SdrElectionDay = stateData.has_sdr_election_day
    ? stateData.has_sdr_election_day.bool_value
    : 'N/A';
  const VbmNoExcuse = stateData.has_no_excuse_absentee
    ? stateData.has_no_excuse_absentee.bool_value
    : 'N/A';
  const VbmExcuseNeeded = stateData.has_no_excuse_absentee
    ? !stateData.has_no_excuse_absentee.bool_value
    : 'N/A';
  const VbmUniversal = stateData.has_automatic_vbm
    ? stateData.has_automatic_vbm.bool_value
    : 'N/A';
  const EarlyVoting = stateData.early_voting_starts
    ? stateData.early_voting_starts.text !== 'N/A'
    : 'N/A';

  return (
    <TableRow>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Same day registration during early voting',
            valueBool: SdrEarlyVoting,
          },
          {
            title: 'Same day registration on election day',
            valueBool: SdrElectionDay,
          },
          {
            title: 'Mail or absentee voting, no excuse needed',
            valueBool: VbmNoExcuse,
          },
          {
            title: 'Mail or absentee voting, excuse needed',
            valueBool: VbmExcuseNeeded,
          },
          {
            title: 'All mail voting',
            valueBool: VbmUniversal,
          },
          {
            title: 'Early voting',
            valueBool: EarlyVoting,
          },
        ]}
      />
    </TableRow>
  );
}

WaysToVoteRowRenderer.propTypes = rowRendererProps;
